import * as React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import { Checkbox, FormControlLabel, FormGroup, Stack } from "@mui/material";
import styled from "styled-components";
import { LoadingButton } from "@mui/lab";
import { useActiveIntegrations } from "src/scenes/dashboard/active-integrations-provider";
import request from "../../utils/request";

const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    minWidth: "200px",
    bgcolor: "background.paper",
    borderRadius: 4,
    boxShadow: 24,
    p: 4,
};

const SubtitleText = styled.span`
    font-size: 12px;
    font-weight: 400;
    color: ${({ theme }) => theme.palette.primary.main};
`;

const CentrallyManagedModal = ({ open, handleClose, accounts }) => {
    const [loading, setLoading] = useState();
    const [microsoft, setMicrosoft] = useState(true);
    const [gitlabSelfManaged, setGitlabSelfManaged] = useState(true);
    const [notion, setNotion] = useState(true);
    const [slack, setSlack] = useState(true);
    const [github, setGithub] = useState(true);
    const [jira, setJira] = useState(true);
    const [google, setGoogle] = useState(true);
    const { activeIntegrations } = useActiveIntegrations();

    const STORAGE_NAME = "dormInt";

    const assignAccounts = async () => {
        try {
            setLoading(true);
            await request(`/api/users/me/dormant-integrations`, {
                method: "PUT",
                body: JSON.stringify(accounts.map(({ name, ...rest }) => rest)),
            });
            activeIntegrations.refetch();
            handleClose();
        } finally {
            setLoading(false);
        }
    };

    const handleSubmitStart = async () => {
        assignAccounts();
    };

    const dormantGitlabSelfManaged = accounts.find(
        (account) => account.integration === "gitlabSelfManaged"
    );
    const dormantMicrosoft = accounts.find((account) => account.integration === "microsoft");
    const dormantNotion = accounts.find((account) => account.integration === "notion");
    const dormantSlack = accounts.find((account) => account.integration === "slack");
    const dormantGithub = accounts.find((account) => account.integration === "github");
    const dormantJira = accounts.find((account) => account.integration === "jira");
    const dormantGoogle = accounts.find((account) => account.integration === "google");

    return (
        <div>
            <Modal
                open={open}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Stack>
                    <Box sx={style}>
                        <Typography id="modal-modal-title" variant="h6" component="h2">
                            We found already existing account for you
                        </Typography>
                        <FormGroup>
                            {dormantGitlabSelfManaged && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={gitlabSelfManaged}
                                            onChange={(event) =>
                                                setGitlabSelfManaged(event.target.checked)
                                            }
                                        />
                                    }
                                    label={
                                        <SubtitleText id="modal-modal-description" sx={{ mt: 2 }}>
                                            Use gitlab account with id{" "}
                                            {dormantGitlabSelfManaged.name}?
                                        </SubtitleText>
                                    }
                                />
                            )}
                            {dormantMicrosoft && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={microsoft}
                                            onChange={(event) => setMicrosoft(event.target.checked)}
                                        />
                                    }
                                    label={
                                        <SubtitleText id="modal-modal-description" sx={{ mt: 2 }}>
                                            Use microsoft account with email {dormantMicrosoft.name}
                                            ?
                                        </SubtitleText>
                                    }
                                />
                            )}
                            {dormantNotion && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={notion}
                                            onChange={(event) => setNotion(event.target.checked)}
                                        />
                                    }
                                    label={
                                        <SubtitleText id="modal-modal-description" sx={{ mt: 2 }}>
                                            Use notion account with id {dormantNotion.name}?
                                        </SubtitleText>
                                    }
                                />
                            )}
                            {dormantGithub && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={github}
                                            onChange={(event) => setGithub(event.target.checked)}
                                        />
                                    }
                                    label={
                                        <SubtitleText id="modal-modal-description" sx={{ mt: 2 }}>
                                            Use GitHub account with id {dormantGithub.name}?
                                        </SubtitleText>
                                    }
                                />
                            )}
                            {dormantJira && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={jira}
                                            onChange={(event) => setJira(event.target.checked)}
                                        />
                                    }
                                    label={
                                        <SubtitleText id="modal-modal-description" sx={{ mt: 2 }}>
                                            Use Jira account with id {dormantJira.name}?
                                        </SubtitleText>
                                    }
                                />
                            )}
                            {dormantSlack && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={slack}
                                            onChange={(event) => setSlack(event.target.checked)}
                                        />
                                    }
                                    label={
                                        <SubtitleText id="modal-modal-description" sx={{ mt: 2 }}>
                                            Use slack account with email {dormantSlack.name}?
                                        </SubtitleText>
                                    }
                                />
                            )}
                            {dormantGoogle && (
                                <FormControlLabel
                                    control={
                                        <Checkbox
                                            checked={google}
                                            onChange={(event) => setGoogle(event.target.checked)}
                                        />
                                    }
                                    label={
                                        <SubtitleText id="modal-modal-description" sx={{ mt: 2 }}>
                                            Use google account with email {dormantGoogle.name}?
                                        </SubtitleText>
                                    }
                                />
                            )}
                        </FormGroup>
                        <Stack
                            direction="column"
                            sx={{
                                typography: "body1",
                                paddingTop: "26px",
                            }}
                            spacing={2}
                        >
                            <Stack
                                direction="row"
                                justifyContent="flex-end"
                                spacing={2}
                                style={{ width: "100%" }}
                            >
                                <LoadingButton
                                    color="secondary"
                                    size="medium"
                                    onClick={() => {
                                        localStorage.setItem(STORAGE_NAME, "no");
                                        handleClose();
                                    }}
                                    loading={loading}
                                >
                                    No
                                </LoadingButton>
                                <LoadingButton
                                    variant="contained"
                                    size="medium"
                                    loading={loading}
                                    onClick={handleSubmitStart}
                                >
                                    Yes
                                </LoadingButton>
                            </Stack>
                        </Stack>
                    </Box>
                </Stack>
            </Modal>
        </div>
    );
};

export default CentrallyManagedModal;
